import { render } from "./AddOffre.vue?vue&type=template&id=2928012f&scoped=true&ts=true"
import script from "./AddOffre.vue?vue&type=script&lang=ts"
export * from "./AddOffre.vue?vue&type=script&lang=ts"

import "./AddOffre.vue?vue&type=style&index=0&id=2928012f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2928012f"]])

export default __exports__